import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  AssociateOptionCategoryPayload, CategoryOrderUpdatePayload,
  CubicleOption,
  CubicleOptionValue, EditCategoryPayload, OptionOrderUpdatePayload
} from '../../../../shared/model/cubicleOption-model';
import {Range} from "../../../../shared/model/range-model";
import {Reference} from "../../../../configuration/shared/model/reference";
import {OptionsService} from "../../../../shared/services/options.service";
import {SwitchBoardComponent} from "../../../../configuration/shared/model/component";
import {MessageService} from "primeng/api";
import {CustomTranslateLoader} from "../../../../shared/localization/CustomTranslateLoader";
import {TranslateService} from "@ngx-translate/core";
import {UploadService} from "../../../shared";
import {LoggerService} from "../../../../shared/logging/logger.service";
import {finalize} from "rxjs";

@Component({
  standalone: false,
  selector: 'app-odm-options-list-references',
  templateUrl: './odm-options-list-references.component.html',
  styleUrls: ['./odm-options-list-references.component.less']
})
export class OdmOptionsListReferencesComponent {

  @Input()
  references: Reference[] = [];


  @Input()
  options: Map<string, CubicleOption[]>;

  @Input()
  isExpanded = false;

  @Input()
  activeOption: string;

  @Input()
  showOnPopUpStatus: boolean = true;

  @Input()
  option: CubicleOption;

  @Input()
  selectedRange: Range;

  isLoading = false;
  displayedOptions: CubicleOption[] = [];

  @Output()
  clickEditOptionButton: EventEmitter<CubicleOption> = new EventEmitter<CubicleOption>();
  @Output()
  clickEditCategoryName: EventEmitter<EditCategoryPayload> = new EventEmitter<EditCategoryPayload>();
  @Output()
  clickEditCategoryAssociation: EventEmitter<AssociateOptionCategoryPayload> = new EventEmitter<AssociateOptionCategoryPayload>();

  @Output()
  clickDeleteCategoryAssociation: EventEmitter<AssociateOptionCategoryPayload> = new EventEmitter<AssociateOptionCategoryPayload>();
  @Output()
  clickDeleteOptionButton: EventEmitter<CubicleOption> = new EventEmitter<CubicleOption>();
  @Output()
  clickCopyOptionButton: EventEmitter<CubicleOption> = new EventEmitter<CubicleOption>();
  @Output()
  clickEditOptionValueButton: EventEmitter<{option: CubicleOption, optionValue: CubicleOptionValue}> = new EventEmitter<{option: CubicleOption, optionValue: CubicleOptionValue}>();
  @Output()
  clickDeleteOptionValueButton: EventEmitter<{option: CubicleOption, optionValue: CubicleOptionValue}> = new EventEmitter<{option: CubicleOption, optionValue: CubicleOptionValue}>();
  @Output()
  changeOptionsOrderEvent: EventEmitter<{option: CubicleOption,currentIndex: number}> = new EventEmitter<{option: CubicleOption, currentIndex: number}>();
  @Output()
  changeCategoryOrderEvent = new EventEmitter<CategoryOrderUpdatePayload>();
  @Output()
  changeOptionOrderEvent = new EventEmitter<OptionOrderUpdatePayload>();


  constructor(private readonly optionsService: OptionsService,
              private readonly messageService: MessageService,
              private readonly customTranslateLoader: CustomTranslateLoader,
              private readonly translateService: TranslateService) { }

  onClickEditOptionButton(option: CubicleOption) {
    this.clickEditOptionButton.emit(option);
  }

  onClickEditCategoryName(option: EditCategoryPayload) {
    this.clickEditCategoryName.emit(option);
  }

  onClickEditCategoryAssociation(option: AssociateOptionCategoryPayload) {
    this.clickEditCategoryAssociation.emit(option);
  }

  onClickDeleteCategoryAssociation(payload: AssociateOptionCategoryPayload) {
    this.clickDeleteCategoryAssociation.emit(payload);
  }

  onClickDeleteOptionButton(option: CubicleOption) {
    this.clickDeleteOptionButton.emit(option);
  }

  onClickCopyOptionButton(option: CubicleOption) {
    this.clickCopyOptionButton.emit(option);
  }

  onClickEditOptionValueButton(event: { option: CubicleOption, optionValue: CubicleOptionValue }) {
    this.clickEditOptionValueButton.emit(event);
  }

  onClickDeleteOptionValueButton(event: { option: CubicleOption, optionValue: CubicleOptionValue }) {
    this.clickDeleteOptionValueButton.emit(event);
  }

  onChangeCategoryOrder(payload: any): void {
    this.changeCategoryOrderEvent.emit(payload);
  }

  onChangeOptionOrder(payload: any) {
    this.changeOptionOrderEvent.emit(payload);
  }
}
